import { IndexSort } from "@omni/types/api/search/algolia/shared/enum/indexSort.enum";

import {
    Sort,
    SortConfiguration
} from "@/components/Search/SearchResults/StateComponents/Sort/sort.container";
import { SearchComponent } from "@/utils/search/types/searchComponent";

const productSortByConfiguration: Array<SortConfiguration> = [
    {
        tkLabel: "search.filters.sort.default",
        value: IndexSort.Default,
        default: true
    },
    {
        tkLabel: "search.filters.sort.price-asc",
        value: IndexSort.PriceAsc
    },
    {
        tkLabel: "search.filters.sort.price-desc",
        value: IndexSort.PriceDesc
    },
    {
        tkLabel: "search.filters.sort.rating-desc",
        value: IndexSort.OverallRatingDesc
    }
];

type ProductSortProps = {
    className?: string;
};

const ProductSort = ({ className }: ProductSortProps) => (
    <Sort
        className={className}
        component={SearchComponent.PRODUCT_SORT}
        configuration={productSortByConfiguration}
    />
);

export { ProductSort };
